<template>
	<v-dialog v-model="visible_local" :max-width="maxWidth" persistent>
		<div class="share-dialog pa-6">
			<v-row class="ma-0" justify="space-between">
				<div class="share-title">Find Timesheets</div>
				<v-btn icon @click="onClose()">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-row>
			<ProgressLinear v-if="loading"/>
			<v-row v-if="!loading" class="mx-0 mt-2 mb-4" justify="space-between">
				<v-row class="ma-0" justify="start" align="center">
					<div class="share-text mr-2">Filters</div>
					<v-menu :close-on-content-click="false" offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="text-capitalize"
								color="#FAFAFA"
								v-bind="attrs"
								v-on="on"
								@click="is_down = !is_down"
							>
								<span class="mr-5" style="font-weight: 500; color: rgba(25, 42, 62, 0.7)">Employee</span>
								<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div style="max-height: 40vh; width: 45vh;">
							<div class="tree-wrap" style="background-color: white;">
								<div class="tree-wrap-container">
									<v-text-field
										v-model="search_key"
										:color="color"
										background-color="#FFFFFF"
										prepend-inner-icon="search"
										placeholder="Search employees and freelancers"
										dense
										hide-no-data
										hide-details
										clearable
										outlined
										rows="1"
										auto-grow
										@click:clear.stop="employeeFilter(null)"
										@input="employeeFilter"
									>
									</v-text-field>
									<div v-for="item in employee_items" :key="item.id" >
										<v-list-item dense>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="employee_select"
												:label="item.display_name"
												:value="item"
												:color="color"
												dense
												hide-details
												@click="onClickCheckBox(item)"
											></v-checkbox>
										</v-list-item>
									</div>
								</div>
							</div>
						</div>
					</v-menu>
					<v-menu :close-on-content-click="false" offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="text-capitalize mx-2"
								color="#FAFAFA"
								v-bind="attrs"
								v-on="on"
							>
								<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20" class="mr-2"/> 				
								<span style="font-weight: 500; color: rgba(25, 42, 62, 0.7)">Date range</span>
							</v-btn>
						</template>
						<v-card color="transparent" elevation="0">
							<v-row class="ma-0">
								<v-date-picker
									v-model="dates_local"
									:color="color"
									no-title
									scrollable
									range
									next-icon=""
									:max="maxPreMonth"
									:picker-date.sync="pickerPreDate"
									@update:picker-date="onPreMonthChange($event)"
								>
								</v-date-picker>
								<v-date-picker
									v-model="dates_local"
									:color="color"
									no-title
									scrollable
									range
									prev-icon=""
									:min="minNextMonth"
									:picker-date.sync="pickerNextDate"
									@update:picker-date="onNextMonthChange($event)"
								></v-date-picker>
							</v-row>
						</v-card>
					</v-menu>
					<v-btn class="text-capitalize white--text" :color="color" :disabled="!isApplyActive" @click="onApplyFilter()">Apply filters</v-btn>
					<v-btn class="text-capitalize ml-2" color="rgba(25, 42, 62, 0.7)" text @click="onClearFilter()">Clear filters</v-btn>
				</v-row>
				<v-menu :close-on-content-click="false" offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="text-capitalize mx-2"
							color="#FAFAFA"
							v-bind="attrs"
							v-on="on"
						>
							<ColumnsTable :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20" class="mr-2"/>
							<span style="font-weight: 500; color: rgba(25, 42, 62, 0.7)">Column selection</span>
						</v-btn>
					</template>
					<div style="max-height: 60vh; background-color: white;">
						<div class="tree-wrap">
							<v-draggable v-model="timesheet_header" class="tree-wrap-container" style="background-color: white">
								<transition-group>
									<div v-for="item in timesheet_header" :key="item.value" >
										<v-list-item dense>
											<DragIcon class="checkbox-text-hover" :color="color" width="20" height="20"/>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_timesheet_header"
												:label="item.text"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</transition-group>
							</v-draggable>
						</div>
					</div>
				</v-menu>
			</v-row>
			<v-alert class="my-2 rounded-a-0" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<v-data-table
				v-if="!loading"
				:headers="timesheet_header"
				:items="timesheetList"
				:page.sync="page"
				:items-per-page="countPerpage"
				hide-default-header
				hide-default-footer
				:header-props="{
					sortIcon: 'mdi-swap-vertical'
				}"
				@click:row="onRowClick"
			>
				<template v-if="!$vuetify.breakpoint.smAndDown" v-slot:header="{ props: { headers } }">
					<thead>
						<tr>
							<th v-for="item in headers" :key="item.value" class="header-th" @mouseover="is_hover = item.value" @mouseout="is_hover = ''">
								<div class="header-item" v-if="item.showable">
									<div class="header-item-text">{{ item.text }}</div>
									<v-btn v-if="item.sortable" icon small :color="is_hover === item.value ? color : '#FAFAFA'" @click="is_ascent = !is_ascent">
										<SortUpDown width="16" height="16" :color="'#FAFAFA'" :selected="is_hover === item.value" :selected_color="color"/>
									</v-btn>
								</div>
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.address_book="{ item }">
					<div v-if="item.address_book">{{ item.address_book.display_name }}</div>
				</template>
				<template v-slot:item.date="{ item }">
					<div v-if="item.date">{{ formatDate(item.date) }}</div>
				</template>
				<template v-slot:item.kind="{ item }">
					<div v-if="item.kind">{{ item.kind.display_name }}</div>
				</template>
				<template v-slot:item.duration="{ item }">
					<div v-if="item.duration">{{ minutesToBudget(item.duration) }}</div>
				</template>
				<template v-slot:item.start="{ item }">
					<div v-if="item.start">{{ formatTime(item.start) }}</div>
				</template>
				<template v-slot:item.stop="{ item }">
					<div v-if="item.stop">{{ formatTime(item.stop) }}</div>
				</template>
				<template v-slot:item.division="{ item }">
					<div v-if="item.division">{{ item.division.display_name }}</div>
				</template>
				<template v-slot:item.value="{ item }">
					<div>{{ formatValue(item.value) }}</div>
				</template>
				<template v-slot:footer>
					<v-row v-if="timesheet_list.length >= perpage" class="pagination ma-0" justify="end">
						<v-pagination
							v-model="page"
							:color="color"
							:length="getPaginationTotal()"
							:total-visible="$vuetify.breakpoint.xs ? 3: 5"
							circle
						></v-pagination>
						<div class="pagination-text">show</div>
						<div class="pagination-text-page">{{ countPerpage}}/page</div>
						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on"><Down class="down"/></div>
							</template>
							<v-list>
								<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
									{{pageOption}}
								</v-list-item-title>
							</v-list>
						</v-menu>
					</v-row>
				</template>
			</v-data-table>
		</div>
	</v-dialog>
</template>
<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import Calendar from "@/components/icons/calendar.vue";
import ColumnsTable from "@/components/icons/columns_table.vue";
import DragIcon from "@/components/icons/drag.vue";
import SortUpDown from '@/components/icons/sort_up_down';
import Down from '@/components/icons/down';

import moment from 'moment';
import config from "@/config.js";

const Select_All = { id: 0, display_name: 'Select all' };
const Timesheet_Header = [
	{
		text: 'Employee',
		value: 'address_book',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Date', 
		value: 'date',
		type: 'text',
		showable: true,
		sortable: true,
		searchable: false,
		divider: false,
		
	},
	{
		text: 'Kind', 
		value: 'kind',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Timesheet duration', 
		value: 'duration',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Start time', 
		value: 'start',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'End time', 
		value: 'stop',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Timesheet description', 
		value: 'notes',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Cost division', 
		value: 'division',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	},
	{
		text: 'Value', 
		value: 'value',
		type: 'text',
		showable: true,
		sortable: false,
		searchable: false,
		divider: false,
	}
];
const PERPAGE = 10;
const Setting_Name = 'DlgTimesheet';

/** If selected the user will be able to see the rate and value for the timesheet entries. */
const TSr = 'TSr';
/** license_type, 2 = 'ATS user', 3 = 'ATS+ user' */
const ATS = 'ATS';

export default {
	name: 'ListTimesheetDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		taskId: {
			type: Number,
			default: 0
		},
	},
	components: {
		ProgressLinear,
		Calendar,
		ColumnsTable,
		DragIcon,
		SortUpDown,
		Down
	},
	data() {
		this.color = '#609800';
		this.perpage = PERPAGE;

		return {
			error_msg: '',
			loading: false,
			visible_local: this.visible,

			employee_select: [],
			employee_items: [],
			employee_items_original: [],
			search_key: '',
			is_down: true,

			dates_local: [],
			pickerPreDate: moment().format('YYYY-MM'),
			pickerNextDate: moment().add(1, 'M').format('YYYY-MM'),

			timesheet_header: Timesheet_Header,
			select_timesheet_header: Timesheet_Header,
			timesheet_list: [],
			timesheet_list_original: [],

			is_hover: '',
			is_ascent: false,

			page: 1,
			countPerpage: PERPAGE,
			pageOptions: config.pageOptions,

			windata: null
		}
	},
	created() {
		this.getSettings();
		this.getTimesheetList(this.taskId);

		this.timesheet_header = this.columnFilter(Timesheet_Header);
		this.select_timesheet_header = this.columnFilter(Timesheet_Header);
	},
	watch: {
		select_timesheet_header() {
			const select_value_arr = this.select_timesheet_header.map(header => { return header.value });

			this.timesheet_header.forEach(header => {
				if (select_value_arr.includes(header.value)) {
					header.showable = true;
				} else {
					header.showable = false;
				}
			});
		}
	},
	computed: {
		user_type() {
			let user_type = 0;

			if (this.$store.state.user) {
				user_type = this.$store.state.user.license_type;
			}		

			return user_type;
		},
		timesheetList() {
			let timesheetList_arr = [];

			if (this.timesheet_list.length !== 0) {
				const show_able_arr = this.timesheet_header.filter(header => { return header.showable === true });
				const value_arr = show_able_arr.map(header => { return header.value });

				const arr_filter = [];
				this.timesheet_list.forEach(timesheet => {
					const obj = {};
					value_arr.forEach(key => {
						obj[`${key}`] = timesheet[`${key}`];
					});
					obj['id'] = timesheet.id;

					arr_filter.push(obj)
				});

				if (this.is_ascent && value_arr.includes('date')) {
					arr_filter.sort((a,b) => { return new Date(a.date) - new Date(b.date) })
				} else {
					arr_filter.sort((a,b) => { return new Date(b.date) - new Date(a.date) })
				}

				timesheetList_arr = arr_filter;
			}

			return timesheetList_arr;
		},
		isApplyActive() {
			let isApplyActive = false;

			if (this.employee_select.length !== 0 || this.dates_local.length === 2) {
				isApplyActive = true;
			}

			return isApplyActive;
		},
		maxPreMonth() {
			const date = moment(this.pickerPreDate, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
			return date
		},
		minNextMonth() {
			const date = moment(this.pickerNextDate, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
			return date
		},
		restrictedPrivilege() {
			let isRestricted = false;

			if (this.user_type.includes(ATS) || (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && !this.$store.state.privileges.includes(TSr))) {
				isRestricted = true;
			}
			
			return isRestricted;
		},
	},
	methods: {
		async getSettings() {
			this.loading = true;
			const usid = this.$store.state.user.id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);

								const dlg_perpage = windata.dlg_perpage;
								if (dlg_perpage) {
									this.countPerpage = dlg_perpage;
								}

								const dlg_options = windata.dlg_options;
								if (dlg_options) {
									const timesheet_header_setting = [];
									dlg_options.forEach(option => {
										const header_filter_arr = Timesheet_Header.filter(header => { return header.value === option.value });
										const header_filter = header_filter_arr[0];
										header_filter['showable'] = option.showable;
										timesheet_header_setting.push(header_filter)
									});

									this.timesheet_header = this.columnFilter(timesheet_header_setting);

									const select_timesheet_header_setting = timesheet_header_setting.filter(header => { return header.showable === true });
									this.select_timesheet_header = this.columnFilter(select_timesheet_header_setting);
								}
							}
						}

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.$store.state.user.id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		async getTimesheetList(task_id) {
			this.loading = true;
			let url = `/api/timesheets`;

			const params = [];
			params.push("task_ids=" + task_id);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						data.sort((a,b) => { return new Date(b.date) - new Date(a.date) });

						const employee_list = data.map(d => { return d.address_book });

						const employee_unique = [];
						const obj_tmp = {};
						employee_list.forEach(employee => {
							if (!obj_tmp[employee.id]) {
								employee_unique.push(employee);
								obj_tmp[employee.id] = true;
							}
						});

						this.employee_items_original = employee_unique;						
						this.employee_items = [Select_All, ...employee_unique];

						data.forEach(d => {
							d['value'] = {
								currency: d.div_currency,
								value: d.value
							}
						});
						this.timesheet_list = data;
						this.timesheet_list_original = data;

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		columnFilter(timesheet_header) {
			let column_filter = [];
			
			if (this.restrictedPrivilege) {
				column_filter = timesheet_header.filter(header => { return header.value !== 'value'})
			} else {
				column_filter = timesheet_header;
			}

			return column_filter;
		},
		employeeFilter(queryText) {	
			if (queryText) {
				const searchText = queryText.toLowerCase();
				const employee_items_tmp = this.employee_items_original.filter(item => {
					const name = item.display_name.toLowerCase();
					if (name.includes(searchText)) {
						return item;
					}
				});

				this.employee_select = [];
				this.employee_items = employee_items_tmp;
			} else {
				this.employee_select = [];
				this.employee_items = [Select_All, ...this.employee_items_original] ;
			}
		},
		onClickCheckBox(item) {
			const filter_select_all = this.employee_select.filter(employee => { return employee.id === Select_All.id });
			
			if (item.id === Select_All.id) {
				if (filter_select_all.length !== 0) {
					this.employee_select = this.employee_items;
				}
				if (filter_select_all.length === 0) {
					this.employee_select = [];
				}
			} else {
				const index = this.employee_select.findIndex(employee => { return employee.id === Select_All.id });

				if (this.employee_select.length === this.employee_items_original.length && index === -1) {
					this.employee_select = this.employee_items;
				} else {          
					if (index !== -1) {
						const arr = [];
						this.employee_select.forEach(employee => { 
							if (employee.id !== Select_All.id) {
								arr.push(employee)
							}
						});

						this.employee_select = arr;
					}
				}
			}
		},
		onPreMonthChange(current_month) {
			this.pickerNextDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).add(1, 'M').format('YYYY-MM');
		},
		onNextMonthChange(current_month) {
			this.pickerPreDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).subtract(1, 'M').format('YYYY-MM');
		},
		onApplyFilter() {
			const employee_ids = this.employee_select.map(employee => { return employee.id });
			this.dates_local.sort((a,b) => { return new Date(a) - new Date(b) });
			
			if (employee_ids.length !== 0 && this.dates_local.length === 2) {
				const filter_arr_employee = [];
				this.timesheet_list_original.forEach(timesheet => {
					if (employee_ids.includes(timesheet.address_book.id)) {
						filter_arr_employee.push(timesheet);
					}
				});

				const filter_arr = [];
				filter_arr_employee.forEach(item => {
					const is_same_or_after = moment(item.date).isSameOrAfter(this.dates_local[0]);
					const is_same_or_before = moment(item.date).isSameOrBefore(this.dates_local[1]);
					if (is_same_or_after && is_same_or_before) {
						filter_arr.push(item);
					}
				});

				this.timesheet_list = filter_arr;

			} else if (employee_ids.length !== 0 && this.dates_local.length !== 2) {
				const filter_arr = [];

				this.timesheet_list_original.forEach(timesheet => {
					if (employee_ids.includes(timesheet.address_book.id)) {
						filter_arr.push(timesheet);
					}
				});

				this.timesheet_list = filter_arr;


			} else if (employee_ids.length === 0 && this.dates_local.length === 2) {
				const filter_arr = [];

				this.timesheet_list_original.forEach(item => {
					const is_same_or_after = moment(item.date).isSameOrAfter(this.dates_local[0]);
					const is_same_or_before = moment(item.date).isSameOrBefore(this.dates_local[1]);
					if (is_same_or_after && is_same_or_before) {
						filter_arr.push(item);
					}
				});

				this.timesheet_list = filter_arr;
			}
		},
		onClearFilter() {
			this.employee_select = [];
			this.dates_local = [];
			this.timesheet_list = this.timesheet_list_original;
		},
		onRowClick(row) {
			const timesheet = this.timesheet_list_original.filter(timesheet => { return timesheet.id === row.id });

			this.$emit('openTs', timesheet[0]);
			this.onClose();
		},
		getPaginationTotal() {
			return Math.ceil(this.timesheet_list.length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;	
		},
		onClose() {
			const win_setup_obj = {};
			win_setup_obj['dlg_perpage'] = this.countPerpage;

			const dlg_options = this.timesheet_header.map(header => { return { value: header.value, showable: header.showable }});
			const is_includes_value = dlg_options.findIndex(option => { return option.value === 'value'});
			if (is_includes_value === -1) {
				const obj = {
					value: 'value',
					showable: false
				};
				dlg_options.push(obj);
			}
			win_setup_obj['dlg_options'] = dlg_options;

			const win_setup_str = JSON.stringify(win_setup_obj);
			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
			
			this.$emit('close');
		},
		minutesToBudget(value) {
			let result = 0;

			if (value < 60 && value >= 0) {
				result = `${value}m`;
			}

			if (value >= 60) {
				const hours = Math.floor(value / 60);
				const minutes = value - (hours * 60);
				result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
			}

			return result;
		},
		formatDate(date) {
			let date_str = '';

			if (date && date.length !== 0) {
				date_str = moment(date).format('DD MMM YYYY');
			}

			return date_str;
		},
		formatTime(time) {
			let time_str = '';

			if (time && time.length !== 0) {
				time_str = moment(time, 'HH:mm:ss').format('hh:mm a');
			}

			return time_str;
		},
		formatValue(value) {
			let value_str = '';

			if (value !== null && value !== undefined) {
				value_str = Number(value.value).toFixed(2);
				value_str = `${value.currency.symbol} ${value_str}`;
			}

			return value_str
		}
	}
}
</script>
<style lang="scss" scoped>
.share-dialog {
	background: #E8EAEC;
}
.share-title {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 36px;
	color: #609800;
}
.share-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #609800;
}
.share-btn-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 44px;
  color: #FFFFFF;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.header-th {
	background: #FAFAFA;
	&:hover {
		background: #EAEAEA;
	}
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-item-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	color: #192A3E;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.header-th:hover .icon {
	visibility: visible; 
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}

::v-deep {
	.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
		color: red;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
		color: red;
		background-color: red;
	}
}
				
</style>